// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./navbarUpdated.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  appearance: none;
  margin: 0;
}

body{background:#fff!important}

.noHeader {
  margin-top: 0px;
}

.invoice-print-document {
    display: none;
}

@media print {

    *,
    :after,
    :before {
        text-shadow: none !important;
        box-shadow: none !important;
        height: auto;
        overflow: visible;
        page-break-before: avoid;
    }

    a:not(.btn):not(.form-control-file:after) {
        text-decoration: underline
    }

    abbr[title]:after {
        content: " (" attr(title) ")"
    }

    pre {
        white-space: pre-wrap !important
    }

    blockquote,
    pre {
        border: 1px solid #999;
        page-break-inside: avoid
    }

    thead {
        display: table-header-group
    }

    img,
    tr {
        page-break-inside: avoid
    }

    h2,
    h3,
    p {
        orphans: 3;
        widows: 3
    }

    h2,
    h3 {
        page-break-after: avoid
    }

    @page {
        size: letter portrait;
        margin: 0.25in;
    }

    .container,
    body {
        min-width: 992px !important
    }

    .navbar {
        display: none;
    }

    .badge {
        border: 1px solid #000
    }

    .table {
        border-collapse: collapse !important
    }

    .table td,
    .table th {
        background-color: #fff !important
    }

    .table-bordered td,
    .table-bordered th {
        border: 1px solid #ddd !important
    }

    .tg-mob-menu,footer.tg-footer,header.top-header{
      display:none!important
    }

    .react-router-outlet {
      display: block !important;
      margin: 1cm;
    }

        body {
            min-width: 0 !important;
        }

        body.printing-invoice-document #root {
            display: none !important;
        }

        .modal-backdrop {
            display: none !important;
        }

        .invoice-print-document.is-printing,
        .invoice-print-document.is-printing * {
            visibility: visible !important;
        }

        .invoice-print-document.is-printing {
            display: block !important;
            position: fixed;
            inset: 0;
            width: 100%;
            color: #4d4d4d;
            background: #fff !important;
            opacity: 1 !important;
            font-family: Arial, sans-serif;
            font-size: 10pt;
            line-height: 1.25;
            print-color-adjust: exact;
        }

        .invoice-print-header {
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
            min-height: 1.7in;
        }

        .invoice-print-logo {
            width: 1.55in;
            height: auto;
        }

        .invoice-print-summary {
            box-sizing: border-box;
            width: 3.00in;
            min-height: 1.35in;
            padding: 0.16in 0.2in;
            color: #fff;
            background: #62bb32 !important;
            border-radius: 0.1in;
        }

        .invoice-print-summary > strong {
            display: block;
            margin-bottom: 0.08in;
            font-size: 16pt;
        }

        .invoice-print-summary dl {
            margin: 0;
        }

        .invoice-print-summary dl div {
            display: flex;
            justify-content: space-between;
            gap: 0.15in;
        }

        .invoice-print-summary dt,
        .invoice-print-summary dd {
            margin: 0;
            font-weight: 700;
        }

        .invoice-print-recipient {
            margin-top: 60px;
            min-height: 0.75in;
            color: #5f5f5f;
            font-weight: 700;
        }

        .invoice-print-heading {
            display: grid;
            grid-template-columns: 2fr 1fr;
            column-gap: 0.22in;
            row-gap: 0.08in;
            align-items: center;
            margin: 0.1in 0 0.55in;
        }

        .invoice-print-heading h1 {
            grid-row: span 2;
            margin: 0;
            color: #62bb32;
            font-size: 20pt;
            font-weight: 400;
        }

        .invoice-print-heading div {
            display: grid;
            grid-template-columns: 2.5in ;
            font-size: 10pt;
        }

        .invoice-print-heading a {
            color: #62bb32;
            text-decoration: none;
        }

        .invoice-print-payment-status {
            margin: 0 0 0.12in;
            font-size: 8pt;
        }

        .invoice-print-table {
            width: 100%;
            border: 1px solid #d8e8ce;
            border-radius: 0.08in;
            border-collapse: separate !important;
            border-spacing: 0;
            overflow: hidden;
            table-layout: fixed;
        }

        .invoice-print-table th,
        .invoice-print-table td {
            padding: 0.08in 0.1in;
            text-align: left;
            vertical-align: top;
            border: 0 !important;
            background: #fff !important;
        }

        .invoice-print-table th {
            color: #62bb32;
            font-size: 8pt;
            font-weight: 700;
            border-bottom: 1px solid #d8e8ce !important;
        }

        .invoice-print-table th:nth-child(1) { width: 15%; }
        .invoice-print-table th:nth-child(2) { width: 43%; }
        .invoice-print-table th:nth-child(3) { width: 20%; }
        .invoice-print-table th:nth-child(4) { width: 22%; }
}
`, "",{"version":3,"sources":["webpack://./src/styles/globals.css"],"names":[],"mappings":"AAEA;;EAIE,gBAAgB;EAChB,SAAS;AACX;;AAEA,KAAK,yBAAyB;;AAE9B;EACE,eAAe;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI;;;QAGI,4BAA4B;QAC5B,2BAA2B;QAC3B,YAAY;QACZ,iBAAiB;QACjB,wBAAwB;IAC5B;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI,sBAAsB;QACtB;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;;QAGI,UAAU;QACV;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,qBAAqB;QACrB,cAAc;IAClB;;IAEA;;QAEI;IACJ;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;MACE;IACF;;IAEA;MACE,yBAAyB;MACzB,WAAW;IACb;;QAEI;YACI,uBAAuB;QAC3B;;QAEA;YACI,wBAAwB;QAC5B;;QAEA;YACI,wBAAwB;QAC5B;;QAEA;;YAEI,8BAA8B;QAClC;;QAEA;YACI,yBAAyB;YACzB,eAAe;YACf,QAAQ;YACR,WAAW;YACX,cAAc;YACd,2BAA2B;YAC3B,qBAAqB;YACrB,8BAA8B;YAC9B,eAAe;YACf,iBAAiB;YAEjB,yBAAyB;QAC7B;;QAEA;YACI,aAAa;YACb,uBAAuB;YACvB,8BAA8B;YAC9B,iBAAiB;QACrB;;QAEA;YACI,aAAa;YACb,YAAY;QAChB;;QAEA;YACI,sBAAsB;YACtB,aAAa;YACb,kBAAkB;YAClB,qBAAqB;YACrB,WAAW;YACX,8BAA8B;YAC9B,oBAAoB;QACxB;;QAEA;YACI,cAAc;YACd,qBAAqB;YACrB,eAAe;QACnB;;QAEA;YACI,SAAS;QACb;;QAEA;YACI,aAAa;YACb,8BAA8B;YAC9B,WAAW;QACf;;QAEA;;YAEI,SAAS;YACT,gBAAgB;QACpB;;QAEA;YACI,gBAAgB;YAChB,kBAAkB;YAClB,cAAc;YACd,gBAAgB;QACpB;;QAEA;YACI,aAAa;YACb,8BAA8B;YAC9B,kBAAkB;YAClB,eAAe;YACf,mBAAmB;YACnB,sBAAsB;QAC1B;;QAEA;YACI,gBAAgB;YAChB,SAAS;YACT,cAAc;YACd,eAAe;YACf,gBAAgB;QACpB;;QAEA;YACI,aAAa;YACb,6BAA6B;YAC7B,eAAe;QACnB;;QAEA;YACI,cAAc;YACd,qBAAqB;QACzB;;QAEA;YACI,kBAAkB;YAClB,cAAc;QAClB;;QAEA;YACI,WAAW;YACX,yBAAyB;YACzB,qBAAqB;YACrB,oCAAoC;YACpC,iBAAiB;YACjB,gBAAgB;YAChB,mBAAmB;QACvB;;QAEA;;YAEI,qBAAqB;YACrB,gBAAgB;YAChB,mBAAmB;YACnB,oBAAoB;YACpB,2BAA2B;QAC/B;;QAEA;YACI,cAAc;YACd,cAAc;YACd,gBAAgB;YAChB,2CAA2C;QAC/C;;QAEA,uCAAuC,UAAU,EAAE;QACnD,uCAAuC,UAAU,EAAE;QACnD,uCAAuC,UAAU,EAAE;QACnD,uCAAuC,UAAU,EAAE;AAC3D","sourcesContent":["@import url(\"./navbarUpdated.css\");\n\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  margin: 0;\n}\n\nbody{background:#fff!important}\n\n.noHeader {\n  margin-top: 0px;\n}\n\n.invoice-print-document {\n    display: none;\n}\n\n@media print {\n\n    *,\n    :after,\n    :before {\n        text-shadow: none !important;\n        box-shadow: none !important;\n        height: auto;\n        overflow: visible;\n        page-break-before: avoid;\n    }\n\n    a:not(.btn):not(.form-control-file:after) {\n        text-decoration: underline\n    }\n\n    abbr[title]:after {\n        content: \" (\" attr(title) \")\"\n    }\n\n    pre {\n        white-space: pre-wrap !important\n    }\n\n    blockquote,\n    pre {\n        border: 1px solid #999;\n        page-break-inside: avoid\n    }\n\n    thead {\n        display: table-header-group\n    }\n\n    img,\n    tr {\n        page-break-inside: avoid\n    }\n\n    h2,\n    h3,\n    p {\n        orphans: 3;\n        widows: 3\n    }\n\n    h2,\n    h3 {\n        page-break-after: avoid\n    }\n\n    @page {\n        size: letter portrait;\n        margin: 0.25in;\n    }\n\n    .container,\n    body {\n        min-width: 992px !important\n    }\n\n    .navbar {\n        display: none;\n    }\n\n    .badge {\n        border: 1px solid #000\n    }\n\n    .table {\n        border-collapse: collapse !important\n    }\n\n    .table td,\n    .table th {\n        background-color: #fff !important\n    }\n\n    .table-bordered td,\n    .table-bordered th {\n        border: 1px solid #ddd !important\n    }\n\n    .tg-mob-menu,footer.tg-footer,header.top-header{\n      display:none!important\n    }\n\n    .react-router-outlet {\n      display: block !important;\n      margin: 1cm;\n    }\n\n        body {\n            min-width: 0 !important;\n        }\n\n        body.printing-invoice-document #root {\n            display: none !important;\n        }\n\n        .modal-backdrop {\n            display: none !important;\n        }\n\n        .invoice-print-document.is-printing,\n        .invoice-print-document.is-printing * {\n            visibility: visible !important;\n        }\n\n        .invoice-print-document.is-printing {\n            display: block !important;\n            position: fixed;\n            inset: 0;\n            width: 100%;\n            color: #4d4d4d;\n            background: #fff !important;\n            opacity: 1 !important;\n            font-family: Arial, sans-serif;\n            font-size: 10pt;\n            line-height: 1.25;\n            -webkit-print-color-adjust: exact;\n            print-color-adjust: exact;\n        }\n\n        .invoice-print-header {\n            display: flex;\n            align-items: flex-start;\n            justify-content: space-between;\n            min-height: 1.7in;\n        }\n\n        .invoice-print-logo {\n            width: 1.55in;\n            height: auto;\n        }\n\n        .invoice-print-summary {\n            box-sizing: border-box;\n            width: 3.00in;\n            min-height: 1.35in;\n            padding: 0.16in 0.2in;\n            color: #fff;\n            background: #62bb32 !important;\n            border-radius: 0.1in;\n        }\n\n        .invoice-print-summary > strong {\n            display: block;\n            margin-bottom: 0.08in;\n            font-size: 16pt;\n        }\n\n        .invoice-print-summary dl {\n            margin: 0;\n        }\n\n        .invoice-print-summary dl div {\n            display: flex;\n            justify-content: space-between;\n            gap: 0.15in;\n        }\n\n        .invoice-print-summary dt,\n        .invoice-print-summary dd {\n            margin: 0;\n            font-weight: 700;\n        }\n\n        .invoice-print-recipient {\n            margin-top: 60px;\n            min-height: 0.75in;\n            color: #5f5f5f;\n            font-weight: 700;\n        }\n\n        .invoice-print-heading {\n            display: grid;\n            grid-template-columns: 2fr 1fr;\n            column-gap: 0.22in;\n            row-gap: 0.08in;\n            align-items: center;\n            margin: 0.1in 0 0.55in;\n        }\n\n        .invoice-print-heading h1 {\n            grid-row: span 2;\n            margin: 0;\n            color: #62bb32;\n            font-size: 20pt;\n            font-weight: 400;\n        }\n\n        .invoice-print-heading div {\n            display: grid;\n            grid-template-columns: 2.5in ;\n            font-size: 10pt;\n        }\n\n        .invoice-print-heading a {\n            color: #62bb32;\n            text-decoration: none;\n        }\n\n        .invoice-print-payment-status {\n            margin: 0 0 0.12in;\n            font-size: 8pt;\n        }\n\n        .invoice-print-table {\n            width: 100%;\n            border: 1px solid #d8e8ce;\n            border-radius: 0.08in;\n            border-collapse: separate !important;\n            border-spacing: 0;\n            overflow: hidden;\n            table-layout: fixed;\n        }\n\n        .invoice-print-table th,\n        .invoice-print-table td {\n            padding: 0.08in 0.1in;\n            text-align: left;\n            vertical-align: top;\n            border: 0 !important;\n            background: #fff !important;\n        }\n\n        .invoice-print-table th {\n            color: #62bb32;\n            font-size: 8pt;\n            font-weight: 700;\n            border-bottom: 1px solid #d8e8ce !important;\n        }\n\n        .invoice-print-table th:nth-child(1) { width: 15%; }\n        .invoice-print-table th:nth-child(2) { width: 43%; }\n        .invoice-print-table th:nth-child(3) { width: 20%; }\n        .invoice-print-table th:nth-child(4) { width: 22%; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
